module.exports = __webpack_public_path__ + "media/images/provider-logo-d055914218c9c9c6720866f74d071abc.png";